module.exports = __webpack_public_path__ + "img/product.5ed4b13f.svg";